
// redux (action-types)
import {CHANGE, CHANGE_DRAWING, SET_IMAGE_ID, CHANGE_CODE} from 'redux/reducers/exam/content/questions/question/workings/action-types'


const saveWorkings = (questionId, value) => ({type: CHANGE, questionId, value});
const saveDrawing = (questionId, drawing) => ({type: CHANGE_DRAWING, questionId, drawing});
const setWorkingsImageId = (questionId, imageId) => ({type: SET_IMAGE_ID, questionId, imageId});
const saveCode = (questionId, code) => ({type: CHANGE_CODE, questionId, code});


export {saveWorkings, saveDrawing, setWorkingsImageId, saveCode}
